"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackMultipleChoiceAnswerSubmitted = exports.trackEmailSubmitted = exports.trackSurveyFreeTextSubmitted = exports.trackSurveyScoreSelected = exports.trackSurveyExited = exports.trackSurveySeen = void 0;
const common_buoy_analytics_1 = require("@buoyhealth/common.buoy-analytics");
const category = "helpfulness-survey";
function trackSurveySeen(uuid, questionText) {
    (0, common_buoy_analytics_1.logExposure)({
        testName: category,
        testVariant: questionText,
    });
    (0, common_buoy_analytics_1.trackStructuredEvent)({
        action: "seen",
        category,
        label: uuid,
        property: questionText,
    });
}
exports.trackSurveySeen = trackSurveySeen;
function trackSurveyExited(uuid) {
    (0, common_buoy_analytics_1.trackStructuredEvent)({
        action: "exited",
        category,
        label: uuid,
    });
}
exports.trackSurveyExited = trackSurveyExited;
const trackSurveyScoreSelected = (uuid, value) => {
    (0, common_buoy_analytics_1.trackStructuredEvent)({
        action: "selected-score",
        category,
        label: uuid,
        property: value,
    });
};
exports.trackSurveyScoreSelected = trackSurveyScoreSelected;
const trackSurveyFreeTextSubmitted = (uuid, value) => {
    (0, common_buoy_analytics_1.trackStructuredEvent)({
        action: "submitted-free-text",
        category,
        label: uuid,
        property: value,
    });
};
exports.trackSurveyFreeTextSubmitted = trackSurveyFreeTextSubmitted;
const trackEmailSubmitted = (uuid) => {
    (0, common_buoy_analytics_1.trackStructuredEvent)({
        action: "submitted-email",
        category,
        label: uuid,
    });
};
exports.trackEmailSubmitted = trackEmailSubmitted;
const trackMultipleChoiceAnswerSubmitted = (uuid, value) => {
    (0, common_buoy_analytics_1.trackStructuredEvent)({
        action: "selected-unhelpful-reason",
        category,
        label: uuid,
        property: value,
    });
};
exports.trackMultipleChoiceAnswerSubmitted = trackMultipleChoiceAnswerSubmitted;
//# sourceMappingURL=analytics.js.map